const timeRemainingUnits = [
    { factor: 60, leftover: 's' }, // 60 seconds = 1 minute
    { factor: 60, leftover: 'm' }, // 60 minutes = 1 hour
    { factor: 24, leftover: 'h'   }, // 24 hours   = 1 day
    { factor:  7, leftover: 'd'    }, // 7 days     = 1 week (just to get the 'days' value)
];

export const secondsToTime = ( seconds ) => {
    let total = seconds;
    let parts = [];

    for( let unit of timeRemainingUnits ) {
        let remaining = total % unit.factor;
        parts.push(`${remaining}${unit.leftover}`);

        if( total < unit.factor ) {
            break;
        }

        total = Math.trunc(total/unit.factor);
    }

    return parts
        .reverse()
        .join(' ')
    ;
};
